import {
  COMMON,
  type CommonProps,
  type FlexProps,
  type LayoutProps,
} from '#app/theme/constants.js';
import { FLEX, LAYOUT } from '#app/theme/index.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import { css, styled } from 'styled-components';

type SelectMenuListProps = CommonProps & FlexProps & LayoutProps & SXProps;

const SelectMenuList = styled.ul<
  SelectMenuListProps & {
    menuWidthForFixedPosition?: string;
  }
>`
  ${({ menuWidthForFixedPosition }) => css`
    margin: 0;
    padding: 0;
    list-style: none;
    display: block;
    position: relative;
    overscroll-behavior: contain;

    ${menuWidthForFixedPosition
      ? css`
          width: ${menuWidthForFixedPosition};
          position: fixed;
        `
      : null}

    ${COMMON}
    ${FLEX}
    ${LAYOUT}
    ${sx}
  `};
`;

SelectMenuList.displayName = 'SelectMenu.List';

export { SelectMenuList };
